export function waitUntilAvailable<T>(getter: () => T | undefined, checkInterval = 100, timeout = 5000): Promise<T> {
	return new Promise((resolve, reject) => {
		const start = Date.now();

		const interval = setInterval(() => {
			const value = getter();
			if (value !== undefined && value !== null) {
				clearInterval(interval);
				resolve(value);
			} else if (Date.now() - start >= timeout) {
				clearInterval(interval);
				reject(new Error('Variable not instantiated within timeout'));
			}
		}, checkInterval);
	});
}
